import { BasicRequest } from "./basicRequest";
import { LegalIdType } from "./LegalIdType";
import { PhotoIdType } from "./PhotoIdType";

export class ReceiveMoneyPostValidationParameter extends BasicRequest {
    operatorName: string | null = null;

  referenceNumber?: string;
  pin?: string;
  receiveCurrency?: string;
  agentCheckNumber?: string;
  agentCheckType?: string;
  agentCheckAmount?: number;
  get agentCheckAmountSpecified(): boolean {
    return this.agentCheckAmount !== undefined && this.agentCheckAmount !== null;
  }

  customerCheckNumber?: string;
  customerCheckType?: string;
  customerCheckAmount?: number;
  get customerCheckAmountSpecified(): boolean {
    return this.customerCheckAmount !== undefined && this.customerCheckAmount !== null;
  }

  receiverAddress?: string;
  receiverAddress2?: string;
  receiverAddress3?: string;
  receiverCity?: string;
  receiverState?: string;
  receiverZipCode?: string;
  receiverCountry?: string;

  receiverPhotoIdType?: PhotoIdType;
  get receiverPhotoIdTypeSpecified(): boolean {
    return this.receiverPhotoIdType !== undefined && this.receiverPhotoIdType !== null;
  }

  receiverPhotoIdNumber?: string;
  receiverPhotoIdState?: string;
  receiverPhotoIdCountry?: string;

  receiverLegalIdType?: LegalIdType;
  get receiverLegalIdTypeSpecified(): boolean {
    return this.receiverLegalIdType !== undefined && this.receiverLegalIdType !== null;
  }

  receiverLegalIdNumber?: string;
  receiverDob?: Date;
  get receiverDobSpecified(): boolean {
    return this.receiverDob !== undefined && this.receiverDob !== null;
  }

  receiverOccupation?: string;

  thirdPartyFirstName?: string;
  thirdPartyMiddleName?: string;
  thirdPartyLastName?: string;
  thirdPartyLastName2?: string;
  thirdPartyAddress?: string;
  thirdPartyAddress2?: string;
  thirdPartyAddress3?: string;
  thirdPartyCity?: string;
  thirdPartyState?: string;
  thirdPartyZipCode?: string;
  thirdPartyCountry?: string;

  thirdPartyLegalIdType?: LegalIdType;
  get thirdPartyLegalIdTypeSpecified(): boolean {
    return this.thirdPartyLegalIdType !== undefined && this.thirdPartyLegalIdType !== null;
  }

  thirdPartyLegalIdNumber?: string;
  thirdPartyDob?: Date;
  get thirdPartyDobSpecified(): boolean {
    return this.thirdPartyDob !== undefined && this.thirdPartyDob !== null;
  }

  thirdPartyOccupation?: string;
  thirdPartyOrg?: string;

  receiverBirthCity?: string;
  receiverBirthCountry?: string;

  receiverPassportIssueDate?: Date;
  get receiverPassportIssueDateSpecified(): boolean {
    return this.receiverPassportIssueDate !== undefined && this.receiverPassportIssueDate !== null;
  }

  receiverPassportIssueCity?: string;
  receiverPassportIssueCountry?: string;

  pcTerminalNumber: string | null = null;

  agentUseReceiveData?: string;
  billerAccountNumber?: string;
  otherPayoutType?: string;
  otherPayoutAmount?: number;
  get otherPayoutAmountSpecified(): boolean {
    return this.otherPayoutAmount !== undefined && this.otherPayoutAmount !== null;
  }

  cardExpirationMonth?: string;
  cardExpirationYear?: string;
  cardSwiped?: boolean;
  get cardSwipedSpecified(): boolean {
    return this.cardSwiped !== undefined && this.cardSwiped !== null;
  }

  consumerId?: string;
  receiverPhone?: string;
  receiverLegalIdIssueCountry?: string;

  thirdPartyPhotoIdType?: PhotoIdType;
  get thirdPartyPhotoIdTypeSpecified(): boolean {
    return this.thirdPartyPhotoIdType !== undefined && this.thirdPartyPhotoIdType !== null;
  }

  thirdPartyPhotoIdNumber?: string;
  thirdPartyPhotoIdState?: string;
  thirdPartyPhotoIdIssueCountry?: string;
  thirdPartyLegalIdIssueCountry?: string;

  agentConsumerId?: string;
  agentTransactionId?: string;
  mgiTransactionSessionId?: string;
  formFreeStaging?: boolean;
 

  timeToLive?: string;
  public FieldValues: Array<{ key: string; value: string }> = [];

}